export const getPropValue = (value: string | EntityBase | undefined, valueProperty: string | string[] = 'name') => {
  if (!value) {return '';}
  if (typeof valueProperty === 'string') {
    return value[valueProperty];
  }
  return value[valueProperty.filter((item) => value[item])[0] || 'name'] || value?.toString();
};